import request from "@/libs/request";
import {
  CreateProjectGroupsTasksMemosRequest,
  CreateProjectGroupsTasksMemosResponse,
  CreateProjectGroupsTasksRequest,
  CreateProjectGroupsTasksResponse,
  DeleteProjectGroupsTasksMemosResponse,
  InviteProjectGroupsTasksAssigneesRequest,
  InviteProjectGroupsTasksAssigneesResponse,
  ReadProjectGroupsTasksResponse,
  RemoveProjectGroupsTasksAssigneesRequest,
  RemoveProjectGroupsTasksAssigneesResponse,
  Task,
  UpdateProjectGroupsTasksMemosRequest,
  UpdateProjectGroupsTasksMemosResponse,
  UpdateProjectGroupsTasksRequest,
  UpdateProjectGroupsTasksResponse,
} from "@/types/task";

// 프로젝트 그룹 작업 생성
export const createProjectGroupsTasks = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: CreateProjectGroupsTasksRequest;
}): Promise<CreateProjectGroupsTasksResponse> => {
  const response = await request.post<CreateProjectGroupsTasksResponse>(
    `/project-groups/${group_id}/tasks/create`,
    data
  );
  return response.data;
};

// 단일 프로젝트 작업 목록 조회
export const readProjectGroupsTasks = async ({
  group_id,
}: {
  group_id: string;
}): Promise<ReadProjectGroupsTasksResponse> => {
  const response = await request.post<ReadProjectGroupsTasksResponse>(
    `/project-groups/${group_id}/tasks/read`
  );
  return response.data;
};

// 프로젝트 그룹 작업 정보 조회
export const readProjectGroupsOneTask = async ({
  group_id,
  task_id,
}: {
  group_id: string;
  task_id: string;
}): Promise<Task> => {
  const response = await request.post<Task>(
    `/project-groups/${group_id}/tasks/${task_id}/read`
  );
  return response.data;
};

// 프로젝트 그룹 작업 정보 변경
export const updateProjectGroupsTasks = async ({
  group_id,
  task_id,
  data,
}: {
  group_id: string;
  task_id: string;
  data: UpdateProjectGroupsTasksRequest;
}): Promise<UpdateProjectGroupsTasksResponse> => {
  const response = await request.post<UpdateProjectGroupsTasksResponse>(
    `/project-groups/${group_id}/tasks/${task_id}/update`,
    data
  );
  return response.data;
};

// 프로젝트 그룹 작업 담당자 초대
export const inviteProjectGroupsTasksAssignees = async ({
  group_id,
  task_id,
  data,
}: {
  group_id: string;
  task_id: string;
  data: InviteProjectGroupsTasksAssigneesRequest;
}): Promise<InviteProjectGroupsTasksAssigneesResponse> => {
  const response =
    await request.post<InviteProjectGroupsTasksAssigneesResponse>(
      `/project-groups/${group_id}/tasks/${task_id}/invite-assignees`,
      data
    );
  return response.data;
};

// 프로젝트 그룹 작업 담당자 제거
export const deleteProjectGroupsTasksAssignees = async ({
  group_id,
  task_id,
  data,
}: {
  group_id: string;
  task_id: string;
  data: RemoveProjectGroupsTasksAssigneesRequest;
}): Promise<RemoveProjectGroupsTasksAssigneesResponse> => {
  const response =
    await request.post<RemoveProjectGroupsTasksAssigneesResponse>(
      `/project-groups/${group_id}/tasks/${task_id}/remove-assignees`,
      data
    );
  return response.data;
};

// 프로젝트 그룹 작업 메모 추가
export const createProjectGroupsTasksMemos = async ({
  group_id,
  task_id,
  data,
}: {
  group_id: string;
  task_id: string;
  data: CreateProjectGroupsTasksMemosRequest;
}): Promise<CreateProjectGroupsTasksMemosResponse> => {
  const response = await request.post(
    `/project-groups/${group_id}/tasks/${task_id}/memos/create`,
    data
  );
  return response.data;
};

export const updateProjectGroupsTasksMemos = async ({
  group_id,
  task_id,
  memo_id,
  data,
}: {
  group_id: string;
  task_id: string;
  memo_id: string;
  data: UpdateProjectGroupsTasksMemosRequest;
}): Promise<UpdateProjectGroupsTasksMemosResponse> => {
  const response = await request.post(
    `/project-groups/${group_id}/tasks/${task_id}/memos/${memo_id}/update`,
    data
  );
  return response.data;
};

export const deleteProjectGroupsTasksMemos = async ({
  group_id,
  task_id,
  memo_id,
}: {
  group_id: string;
  task_id: string;
  memo_id: string;
}): Promise<DeleteProjectGroupsTasksMemosResponse> => {
  const response = await request.post(
    `/project-groups/${group_id}/tasks/${task_id}/memos/${memo_id}/delete`
  );
  return response.data;
};
